const initialState = {
    assignedIIDArray: [],
    assignedIIDDetails: {},
};

const RouteMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ASSIGNED_IID_ARRAY":
            return {
                ...state,
                assignedIIDArray: action.payload,
            };

        case "ASSIGNED_IID_DETAILS":
            return {
                ...state,
                assignedIIDDetails: action.payload,
            };

        default:
            return state;
    }
};

export default RouteMenuReducer;